
import Vue from 'vue';
import AppContent from '@components/new-styleguide/AppContent.vue';
import InfoBoxWarning from '@components/shared/ui/InfoBoxWarning.vue';
import AppSetupHeader from '@components/vehicle-setup/AppSetupHeader.vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import NextIcon from '@components/icons/icon-next.svg'
import AppPage from '@components/new-styleguide/AppPage.vue';
import { TripLog } from '@/generated-clients/myTrips';

const TriplogModule = namespace('Triplog');

@Component({
  name: 'BasicSetupScreen',
  components: {
    InfoBoxWarning,
    AppContent,
    AppSetupHeader,
    AppPage,
    NextIcon
  }
})
export default class BasicSetupScreen extends Vue {
  @TriplogModule.Getter('getSelectedTriplog')
  private triplog: TripLog;

  @Prop({ required: true })
  private id: string;

  @Prop({ required: true })
  private title: string;

  @Prop({ required: true })
  private nextButtonText: string;

  @Prop({ default: false })
  private hasError: boolean;

  @Prop()
  private headline: string;

  @Prop()
  private confirmationText: string;

  @Prop()
  private helpText: string;

  @Prop()
  private requestError: string;

  private confirmed: boolean = false;
  private screenWidth: number = window.innerWidth;

  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
  }

  destroy() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  private handleWindowResize() {
    this.screenWidth = window.innerWidth;
  }

  get browserView() {
    return this.screenWidth > 767;
  }

  get nextButtonDisabled() {
    return !!this.confirmationText && !this.confirmed;
  }
}
